/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _region = _interopRequireDefault(require("../packages/region"));
var _getGlobal = require("../getGlobal");
var globalObject = (0, _getGlobal.getGlobal)();
var CACHED;
var LISTENING_WINDOW_RESIZE;
var setupWindowResize = function setupWindowResize() {
  LISTENING_WINDOW_RESIZE = true;
  globalObject.addEventListener('resize', function () {
    CACHED = null;
  });
};
function getViewportRegion() {
  if (CACHED) {
    return CACHED;
  }
  if (!LISTENING_WINDOW_RESIZE) {
    setupWindowResize();
  }
  var viewportWidth = Math.max(globalObject.document.documentElement.clientWidth, globalObject.innerWidth || 0);
  var viewportHeight = Math.max(globalObject.document.documentElement.clientHeight, globalObject.innerHeight || 0);
  return CACHED = _region.default.from({
    top: 0,
    left: 0,
    width: viewportWidth,
    height: viewportHeight
  });
}
var _default = getViewportRegion;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/common/getViewportRegion.js
// module id = 213
// module chunks = 0